import { workStatusMessages } from '../../../interfaces';
import { WorkStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';
import { Badge } from '@amzn/awsui-components-console';
import React from 'react';

export const WorkStatusBadge = (props: {
  status: WorkStatus;
  // When true (default), the badge text is prefixed with "Status: ".
  // List/table cells pass false to render just the status text.
  showPrefix?: boolean;
}) => {
  const message = workStatusMessages[props.status];
  const text = message ? message.text : props.status;
  const color = message ? message.color : undefined;
  const showPrefix = props.showPrefix ?? true;

  return <Badge color={color}>{showPrefix ? `Status: ${text}` : text}</Badge>;
};
